<div class="col-size6 t-col-size8 m-col-size4">
  <div class="title">
    {{ 'PROFILE.RGPD_RIGHTS.RIGHTS_PROTECTION_TITLE' | translate }}
  </div>
  <div class="subtitle">
    <span class="subtitle subtitle__span">{{
      'PROFILE.RGPD_RIGHTS.RIGHTS_PROTECTION_SUBTITLE1' | translate
    }}</span>
    <span
      class="subtitle subtitle__span"
      [innerHTML]="rightsProtectionSubtitle2"
    ></span>
    <span class="subtitle subtitle__span">{{
      'PROFILE.RGPD_RIGHTS.RIGHTS_PROTECTION_SUBTITLE3' | translate
    }}</span>
  </div>
  <div class="white-box-footer-buttons mapfre-hide-mobile">
    <ion-button
      [disabled]=""
      class="mapfre-hide-tablet"
      color="primary"
      (click)="onExerciseRights()"
    >
      {{
        'PROFILE.RGPD_RIGHTS.RIGHTS_PROTECTION_EXCERCISE_RIGHTS'
          | translate
          | uppercase
      }}
    </ion-button>
    <ion-button
      [disabled]=""
      class="mapfre-hide-desktop"
      size="medium"
      color="primary"
      (click)="onExerciseRights()"
    >
      {{
        'PROFILE.RGPD_RIGHTS.RIGHTS_PROTECTION_EXCERCISE_RIGHTS'
          | translate
          | uppercase
      }}
    </ion-button>
  </div>
  <ion-button
    [disabled]=""
    size="large"
    *ngIf="!ctx.isApp"
    class="mapfre-hide-desktop mapfre-hide-tablet ion-no-margin"
    expand="block"
    color="primary"
    (click)="onExerciseRights()"
  >
    {{
      'PROFILE.RGPD_RIGHTS.RIGHTS_PROTECTION_EXCERCISE_RIGHTS'
        | translate
        | uppercase
    }}
  </ion-button>
</div>
